import metaDataManager from '../wadors/metaDataManager.js';
export default function getRetrieveValue(imageId, src, attr) {
    const value = src?.[attr];
    if (typeof value !== 'function') {
        return value;
    }
    const metaData = metaDataManager.get(imageId);
    return value(metaData, imageId);
}
